import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidationsService } from '@app/core/services/validations.service';
import { Constants } from '@app/shared/class/constants.class';
import { AppConfig } from '@config/app.config';
import { AccountingService } from '@core/services/accounting.service';
import { GeneralsService } from '@core/services/generals.service';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-totals-costs-download',
  templateUrl: './totals-costs-download.component.html'
})
export class TotalsCostsDownloadComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public transactionLogForm: FormGroup;
  public minDate = moment();
  public maxDate = moment();
  public sentinelData;
  
  constructor(
    public appConfig: AppConfig,
    public accountingService: AccountingService,
    public generalsService: GeneralsService
  ) {}

  ngOnInit() {
    this.transactionLogForm = new FormGroup(
      {
        dateStart: new FormControl('', [
          Validators.required
        ]),
        dateEnd: new FormControl('', [
          Validators.required
        ])
      },
      [ValidationsService.validateRangeDateValue]
    );
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.transactionLogForm;
    if (form.dirty && form.valid) {
      const loading = this.generalsService.loading();
      this.accountingService
        .downloadTotalsCosts(form)
        .pipe(takeUntil(this.constants.destroy$))
        .subscribe(
          result => {
            const fileName = this.generalsService.getFileName(
              result.headers.get('content-disposition')
            );
            this.generalsService.download(fileName, 'txt', result);
            this.accountingService
                .downloadTotalsCostsSentinel(form)
                .pipe(takeUntil(this.constants.destroy$))
                .subscribe(
                  result2 => {
                    const fileName2 = this.generalsService.getFileName(
                      result2.headers.get('content-disposition')
                    );
                    this.generalsService.download(fileName2, 'txt', result2);
                  },
                  error => {
                    loading.close();
                    this.generalsService.notification(
                      this.appConfig.NOTIFICATION.error,
                      this.generalsService.showError(error)
                    );
                  }
                );
            loading.close();
          },
          error => {
            loading.close();
            this.generalsService.notification(
              this.appConfig.NOTIFICATION.error,
              this.generalsService.showError(error)
            );
          }
        );
    }
  }
}
